// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"a959eb82","164":"10586363","354":"6c2461fb","481":"70d8ee0b","488":"f1dc7667","645":"75b6adf0","667":"32834bf1","721":"5d6b82bb","773":"c3082d33","941":"efdc8f27","946":"386ba891"}[chunkId] + ".chunk.js";
};